export default __webpack_public_path__ + "static/media/blog.f9b8ba39.png";